import { useEffect, useState } from "react";
import { transformKeys } from "../../_helper";
import CoursesSection from "../../Components/CoursesSection";
import UserProfileHeader from "../../Components/PartnerProfile/UserProfileHeader";
import ProfileSection from "../../Components/ProfileSection";
import PageTitle from "../../Components/UI/PageTitle";
import { myProfileApi } from "../../apis";
import Loader from "../../Components/Loader";
import ErrorAnimationComponent from "../../assets/lottie/ErrorAnimation/ErrorAnimationComponent";
import { useSelector } from "react-redux";
import { USER_TYPES_CATEGORIES } from "../../constants/globals";
import RenewSubscriptionHistory from "../../Components/RenewSubscriptionHistory";

const MyProfile = () => {
  const { loggedInUser } = useSelector((state) => state.Auth);
  const currentClientCategory =
    loggedInUser?.data?.model?.client?.client_category_id;

  const [isLoading, setIsloading] = useState(true);
  const [isError, setIsError] = useState("");
  const [profielData, setProfileData] = useState([]);

  useEffect(() => {
    setIsloading(true);
    myProfileApi()
      .then((response) => {
        setProfileData(response.data.data);
      })
      .catch((error) => {
        setIsError(error?.response?.data?.message || error.message);
        console.log(error);
      })
      .finally(() => {
        setIsloading(false);
      });
  }, []);

  const MyPersonalData = profielData?.personalData;
  const MyPackageData = profielData?.packageData;
  const subscriptionData = profielData?.subscriptionData;
  const MyAccountData = profielData?.accountData;
  const EMoneyTransactions = profielData?.eMoneyTransactions;
  const coursesData = profielData?.coursesData;

  if (isLoading) return <Loader />;
  if (isError) return <ErrorAnimationComponent message={isError} />;
  return (
    <>
      <PageTitle title={"My Profile"} />
      <div className="tw-flex tw-flex-col tw-gap-4 !tw-m-0">
        <UserProfileHeader
          data={profielData?.profileHeader || []}
          currentClientCategory={currentClientCategory}
        />
        <ProfileSection
          data={transformKeys(MyPersonalData || {})}
          title={"My Personal Data"}
        />
        <ProfileSection
          data={transformKeys(MyAccountData || {})}
          title={"My Account Data"}
        />
        <ProfileSection
          data={transformKeys(MyPackageData?.[0] || [])}
          title={"My Package Data"}
        />
        <CoursesSection courses={coursesData || []} />
        {currentClientCategory === USER_TYPES_CATEGORIES.SERVICE_MARKETING && (
          <ProfileSection
            data={transformKeys(EMoneyTransactions || {})}
            title={"E-Money Transactions"}
          />
        )}
        <RenewSubscriptionHistory
          data={subscriptionData || []}
          title={"Renew Subscription History"}
        />
      </div>
    </>
  );
};

export default MyProfile;
